import React, { useState } from 'react';
import { Typography, Input, Checkbox, Button, Spinner } from '@material-tailwind/react';
import DatePicker from "react-datepicker";
import { MagnifyingGlassIcon, TrashIcon } from '@heroicons/react/24/outline';
import "react-datepicker/dist/react-datepicker.css";
import { Axios, Swal } from '../../../Helpers/importacionesComunes';
import { formatearMontoMoneda } from '../../../Helpers/utilidades-globales';

const Seleccionador = ({
    valor, 
    name, 
    onchange, 
    id, 
    noDefault, 
    nombre, 
    vector, 
    claves, 
    limpiar,
    classancho
  }) => {
    let clasesSelect = "block appearance-none w-100 select-titulo rounded shadow leading-tight";
    if (classancho){
        clasesSelect=`block appearance-none ${classancho} select-titulo rounded shadow leading-tight`
    }
    return (            
        <div className="flex flex-col sel select-ui-data w-full relative">
            <select value={valor} name={name? name : ''} className='h-9 font-semibold text-black w-full rounded border border-gray-300 px-2' onChange ={onchange} id={id? id : null}>
                { noDefault ? null : <option value="*" key="1">{nombre}</option>}
                {vector?.map(item=>
                        <option value={item[claves.id]} key={item[claves.id]} className=''>
                            {item[claves.nombre]}
                        </option> 
                    )}
            </select>
             { valor!="*" && limpiar && 
                <button className="absolute right-6 top-2" onClick={limpiar}>
                    <TrashIcon className="h-4 w-4 text-red-500"/>
                </button>
            }  
        </div>
        )
}

export default function DepositoPrecargado({
    bancos,
    regiones,
    bancoCuentas,
    currentFPago,
    setCurrentFPago
}) {
    const [filtros, setFiltros] = useState({
        id_banco: '',
        localidad: '',
        id_region: '',
        concepto: '',
        id_cuenta_bancaria: bancoCuentas.length > 0 ? bancoCuentas[0].id_cuenta_bancaria : '',
        fechaDesde: (() => { const d = new Date(); d.setDate(d.getDate() - 1); d.setHours(0,0,0,0); return d; })(),
        fechaHasta: (() => { const d = new Date(); d.setHours(23,59,59,999); return d; })(),
        depositosFraccionados: false,
        valor_desde: '0',
        valor_hasta: '10000000'
    });

    const [resultados, setResultados] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedResultados = React.useMemo(() => {
        let sortableItems = [...resultados];
        if (sortConfig.key !== null) {
            sortableItems.sort((a, b) => {
                let aValue = a[sortConfig.key];
                let bValue = b[sortConfig.key];
                
                // Tratar fechas si la clave es fecha
                if (sortConfig.key === 'fecha') {
                    // Trata dd/mm/yyyy
                    if(aValue && typeof aValue === 'string' && aValue.includes('/')) {
                        const [da, ma, ya] = aValue.split('/');
                        aValue = new Date(ya, ma - 1, da).getTime();
                    }
                    if(bValue && typeof bValue === 'string' && bValue.includes('/')) {
                        const [db, mb, yb] = bValue.split('/');
                        bValue = new Date(yb, mb - 1, db).getTime();
                    }
                } else if (sortConfig.key === 'disponible') {
                    aValue = Number(aValue);
                    bValue = Number(bValue);
                }

                if (aValue < bValue) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableItems;
    }, [resultados, sortConfig]);

    const handleSeleccionar = (item) => {
        const montoBruto = Number(item.disponible);
        const tipoCambio = Number(currentFPago.v_cambio_pesos) || 1;
        
        setCurrentFPago({
            ...currentFPago,
            monto: item.disponible,
            fecha: item.fecha,
            predeposito_seleccionado: {
                ...item,
                id_cuenta_bancaria: filtros.id_cuenta_bancaria // Aseguramos que se pase la cuenta seleccioanda
            },
            m_bruto: item.disponible,
            m_neto: (montoBruto / tipoCambio).toFixed(2)
        });
    }

    const handleBuscar = async () => {
        if (!filtros.id_cuenta_bancaria || filtros.id_cuenta_bancaria === "*" || filtros.id_cuenta_bancaria === "") {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Debe seleccionar una cuenta bancaria'
            });
            return;
        }

        if (filtros.valor_desde && filtros.valor_desde !== "" && (!filtros.valor_hasta || filtros.valor_hasta === "")) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Debe ingresar el monto hasta.'
            });
            return;
        }

        setCargando(true);
        try {
            const parametros = {
                id_region: filtros.id_region === "" || filtros.id_region === "*" ? null : Number(filtros.id_region),
                id_cuenta_bancaria: Number(filtros.id_cuenta_bancaria),
                f_desde: filtros.fechaDesde, 
                f_hasta: filtros.fechaHasta,
                fracc: filtros.depositosFraccionados,
                localidad: filtros.localidad === "" ? null : filtros.localidad,
                concepto: filtros.concepto === "" ? null : filtros.concepto,
                valor_desde: (filtros.valor_desde !== null && filtros.valor_desde !== "") ? Number(filtros.valor_desde) : null, 
                valor_hasta: (filtros.valor_hasta !== null && filtros.valor_hasta !== "") ? Number(filtros.valor_hasta) : null
            }
            
            const { data } = await Axios.post('/api/tablasgenerales/ingresos/listarPredepositos', parametros);
            setResultados(data);
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al buscar depósitos precargados'
            });
            setResultados([]);
        } finally {
            setCargando(false);
        }
    }

    return (
        <div className="flex flex-col mt-4 border-t pt-4">
            <Typography variant="h6" color="blue-gray" className="mb-2">
                Depósito precargado
            </Typography>
            
            <div className="bg-blue-50/50 p-4 rounded-lg border border-blue-100 mb-4 relative z-20">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    {/* Fila 1 */}
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
                        <Typography variant="h7" color="blue-gray" className="w-full sm:w-24 font-semibold sm:min-w-[80px]">Cta. Bcaria.</Typography>
                        <div className="w-full">
                                <Seleccionador 
                                vector={bancoCuentas} 
                                valor={filtros.id_cuenta_bancaria} 
                                nombre="Seleccionar" 
                                onchange={(e)=>setFiltros({...filtros, id_cuenta_bancaria: e.target.value})} 
                                claves={{id:'id_cuenta_bancaria', nombre:'descripcion'}}
                            />
                        </div>
                    </div>
                    
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
                         <Typography variant="h7" color="blue-gray" className="w-full sm:w-24 font-semibold sm:min-w-[80px]">Fecha</Typography>
                         <div className="flex gap-2 w-full">
                            <DatePicker 
                                selected={filtros.fechaDesde} 
                                onChange={date => setFiltros({...filtros, fechaDesde: date})} 
                                className="h-9 w-full rounded border border-gray-300 px-2 text-center"
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Desde"
                            />
                            <DatePicker 
                                selected={filtros.fechaHasta} 
                                onChange={date => setFiltros({...filtros, fechaHasta: date})} 
                                className="h-9 w-full rounded border border-gray-300 px-2 text-center"
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Hasta"
                            />
                         </div>
                    </div>

                    {/* Fila 2 */}
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
                        <Typography variant="h7" color="blue-gray" className="w-full sm:w-24 font-semibold sm:min-w-[80px]">Monto</Typography>
                        <div className="grid grid-cols-2 gap-2 w-full">
                            <Input 
                                type="number"
                                placeholder="Min"
                                value={filtros.valor_desde}
                                onChange={(e) => setFiltros({...filtros, valor_desde: e.target.value})}
                                className="!border-t-blue-gray-200 focus:!border-t-gray-900 h-9 bg-white"
                                labelProps={{ className: "before:content-none after:content-none" }}
                                containerProps={{ className: "!min-w-0 !w-full" }}
                            />
                            <Input 
                                type="number"
                                placeholder="Max"
                                value={filtros.valor_hasta}
                                onChange={(e) => setFiltros({...filtros, valor_hasta: e.target.value})}
                                className="!border-t-blue-gray-200 focus:!border-t-gray-900 h-9 bg-white"
                                labelProps={{ className: "before:content-none after:content-none" }}
                                containerProps={{ className: "!min-w-0 !w-full" }}
                            />
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
                        <Typography variant="h7" color="blue-gray" className="w-full sm:w-24 font-semibold sm:min-w-[80px]">Región</Typography>
                        <div className="w-full flex items-center gap-1">
                                <Seleccionador 
                                vector={regiones} 
                                valor={filtros.id_region} 
                                nombre="Todas" 
                                onchange={(e)=>setFiltros({...filtros, id_region: e.target.value})} 
                                claves={{id:'id_region', nombre:'nombre'}}
                            />
                        </div>
                    </div>

                    {/* Fila 3 */}
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
                        <Typography variant="h7" color="blue-gray" className="w-full sm:w-24 font-semibold sm:min-w-[80px]">Concepto</Typography>
                        <Input 
                            value={filtros.concepto}
                            onChange={(e) => setFiltros({...filtros, concepto: e.target.value})}
                            className="!border-t-blue-gray-200 focus:!border-t-gray-900 h-9 bg-white"
                            labelProps={{ className: "before:content-none after:content-none" }}
                            containerProps={{ className: "min-w-0" }}
                        />
                    </div>

                    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
                        <Typography variant="h7" color="blue-gray" className="w-full sm:w-24 font-semibold sm:min-w-[80px]">Localidad</Typography>
                        <Input 
                            value={filtros.localidad}
                            onChange={(e) => setFiltros({...filtros, localidad: e.target.value})}
                            className="!border-t-blue-gray-200 focus:!border-t-gray-900 h-9 bg-white"
                            labelProps={{ className: "before:content-none after:content-none" }}
                            containerProps={{ className: "min-w-0" }}
                        />
                    </div>
                </div>

                {/* Fila 4 (Botón y Checkbox) */}
                <div className="flex flex-wrap items-center justify-between gap-4">
                     <div className="flex items-center">
                        <Checkbox 
                            label="Depósitos fraccionados" 
                            checked={filtros.depositosFraccionados}
                            onChange={(e) => setFiltros({...filtros, depositosFraccionados: e.target.checked})}
                            ripple={false}
                        />
                     </div>

                     <Button variant="gradient" className="flex items-center gap-2 h-9" onClick={handleBuscar} disabled={cargando}>
                        { cargando ? <Spinner className="h-4 w-4" /> : <MagnifyingGlassIcon className="h-4 w-4" /> }
                        { cargando ? 'Buscando...' : 'Buscar' }
                     </Button>
                </div>
            </div>

            {/* Table Results */}
            <div className="overflow-hidden border rounded-md bg-white shadow-sm">
                <div className="max-h-40 overflow-y-auto">
                    <table className="w-full min-w-max table-auto text-left">
                        <thead className="bg-blue-gray-50 sticky top-0 z-10">
                            <tr>
                                <th className="border-b border-blue-gray-100 p-2 text-xs font-semibold text-blue-gray-600 cursor-pointer select-none" onClick={() => requestSort('fecha')}>
                                    fecha {sortConfig.key === 'fecha' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                                </th>
                                <th className="border-b border-blue-gray-100 p-2 text-xs font-semibold text-blue-gray-600 cursor-pointer select-none" onClick={() => requestSort('sucursal')}>
                                    sucursal {sortConfig.key === 'sucursal' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                                </th>
                                <th className="border-b border-blue-gray-100 p-2 text-xs font-semibold text-blue-gray-600 cursor-pointer select-none" onClick={() => requestSort('concepto')}>
                                    concepto {sortConfig.key === 'concepto' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                                </th>
                                <th className="border-b border-blue-gray-100 p-2 text-xs font-semibold text-blue-gray-600 text-right cursor-pointer select-none" onClick={() => requestSort('disponible')}>
                                    disponible {sortConfig.key === 'disponible' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedResultados.map((res, idx) => {
                                const isSelected = currentFPago?.predeposito_seleccionado?.id_mov_cta_dep === res.id_mov_cta_dep;
                                
                                return (
                                <tr 
                                    key={idx} 
                                    className={`cursor-pointer transition-colors border-b border-gray-100 last:border-0 ${isSelected ? 'bg-blue-100 hover:bg-blue-200' : 'hover:bg-blue-50'}`}
                                    onClick={() => handleSeleccionar(res)}
                                >
                                    <td className="p-2 text-xs">{res.fecha}</td>
                                    <td className="p-2 text-xs">{res.sucursal}</td>
                                    <td className="p-2 text-xs">{res.concepto}</td>
                                    <td className="p-2 text-xs font-medium text-right">{formatearMontoMoneda(Number(res.disponible))}</td>
                                </tr>
                                )
                            })}
                            {resultados.length === 0 && (
                                <tr>
                                    <td colSpan={4} className="p-8 text-center text-sm text-gray-500 italic">
                                        No se encontraron resultados para los filtros seleccionados
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
